import React from 'react';
import { DatePicker as AntdDatePicker, DatePickerProps } from 'antd';
import type { Dayjs } from 'dayjs';

type DatePickerRef = React.ElementRef<typeof AntdDatePicker>;

/**
 * Pass-through wrapper that keeps antd's `ValueType` generic, so a `multiple`
 * picker still types its value as `Dayjs[]`.
 *
 * Every react-hook-form call site spreads `field`, which carries `ref`, so the
 * ref has to reach antd for focus-the-first-errored-field to work. `forwardRef`
 * does that here; the cast restores the generic that it erases. (React 19 passes
 * `ref` as a plain prop, so a function component would also do.)
 */
const DatePickerWithRef = React.forwardRef<DatePickerRef, DatePickerProps>(
  function DatePicker(props, ref) {
    return <AntdDatePicker ref={ref} {...props} />;
  }
);

DatePickerWithRef.displayName = 'DatePicker';

export const DatePicker = DatePickerWithRef as <
  ValueType = Dayjs,
  IsMultiple extends boolean = false,
>(
  props: DatePickerProps<ValueType, IsMultiple> & {
    ref?: React.Ref<DatePickerRef>;
  }
) => React.ReactElement;
